import axios from "axios"
import qs from 'querystring'

export default {
  namespaced: true,
  actions: {
    async init({commit}, payload) {
      try {
        const userResponse = await axios.get(`/auth?state=STATE&code=`+payload.code)
        var auth = JSON.parse(localStorage.getItem('auth') || 'null') || {}
        auth = userResponse.data.data
        localStorage.setItem('auth', JSON.stringify(auth))
        commit('setAuth', auth)
        return auth
      } catch (ex) {
        console.log(ex)
        debugger
      }
    }
  },
  mutations: {
    setAuth(state, auth) {
      state.token = auth.token
      state.user = auth.info
    }
  }
}
